import { useDispatch, useSelector } from "react-redux"
import SubmitButton from "../../../components/button/SubmitButton"
import { SNACK_BAR_VARIETNS, USER_ROLES } from "../../../utils/constants"
import { useState } from "react"
import fileDownload from "js-file-download"
import moment from "moment"
import { callApiAction } from "../../../store/actions/commonAction"
import { downloadLessWorkingLogSheetApi, downloadLogSheetApi } from "../../../apis/leave.api"
import { callSnackBar } from "../../../store/actions/snackbarAction"
import { Box } from "@mui/material"

const DownloadLogsCsvButton = ({ date }) => {
    const dispatch = useDispatch()
    const { user } = useSelector(state => state)
    const [loading, setLoading] = useState()
    const fetchList = () => {

        setLoading("dow1")
        dispatch(callApiAction(
            async () => await downloadLogSheetApi({ date: date.toISOString() }),
            (response) => {
                fileDownload(response, moment(date).format("MMMM") + "-logs.csv")
                setLoading(false)
            },
            (err) => {
                dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.error))
                setLoading(false)
            },
            true
        ))

    };


    const fetchListLessWorkingHour = () => {
        setLoading("dow2")
        dispatch(callApiAction(
            async () => await downloadLessWorkingLogSheetApi({ date: date.toISOString() }),
            (response) => {
                fileDownload(response, moment(date).format("MMMM") + "-logs.csv")
                setLoading(false)
            },
            (err) => {
                dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.error))
                setLoading(false)
            },
            true
        ))

    };



    if (user.data.role == USER_ROLES.hr || user.data.role == USER_ROLES.admin || user.data.role == USER_ROLES.hr_recruiter)
        return (
            <Box display="flex" gap={2}>
                <SubmitButton
                    onClick={fetchListLessWorkingHour}
                    loading={loading == "dow2"}
                    title={"Download WH Logs"}
                    sx={{ minWidth: "200px" }}
                />
                <SubmitButton
                    onClick={fetchList}
                    loading={loading == "dow1"}
                    title={"Download Report"}
                />
            </Box>
        );
}
export default DownloadLogsCsvButton